__turbopack_context__.v({
  "focusWrapper": "styles-module__xl5mWq__focusWrapper",
});
